import { TmBaseError } from './tmBaseError'

export class TmRepositoryError extends TmBaseError {
  public name = 'RepositoryError'
}
